import { withAppBasePath } from "@/app/lib/withAppBasePath";

export type BlogPreviewApiParams = {
  campaignId: string;
  blogId: string;
  supplierId?: string;
  layout?: string;
  version?: number;
};

/** Same-origin BFF — HTML preview from saved campaign draft only. */
export function blogPreviewApiPath(params: BlogPreviewApiParams): string | null {
  const cid = params.campaignId?.trim();
  const bid = params.blogId?.trim();
  if (!cid || !bid) return null;

  const search = new URLSearchParams({ campaignId: cid, blogId: bid });
  const sid = params.supplierId?.trim();
  if (sid) search.set("supplierId", sid);
  search.set("layout", (params.layout || "wireframe").trim());
  if (params.version != null && params.version > 0) {
    search.set("v", String(params.version));
  }
  return withAppBasePath(`/api/blog-preview?${search.toString()}`);
}

export type CampaignBlogLiveParams = {
  campaignId: string;
  supplierId?: string;
  title?: string;
  version?: number;
};

/** Public live URL — `/ai/blogs/ideas/{blogId}?campaignId=…&supplierId=…` */
export function campaignBlogLivePath(blogId: string, params: CampaignBlogLiveParams): string {
  const path = withAppBasePath(`/blogs/ideas/${blogId}`);
  const qs = new URLSearchParams();
  const cid = params.campaignId?.trim();
  if (cid) qs.set("campaignId", cid);
  const sid = params.supplierId?.trim();
  if (sid) qs.set("supplierId", sid);
  const t = params.title?.trim();
  if (t) qs.set("title", t);
  if (params.version != null && params.version > 0) {
    qs.set("v", String(params.version));
  }
  const q = qs.toString();
  return q ? `${path}?${q}` : path;
}
